export default {
    locale: 'en-NZ',
    dismissAlertText: 'Close'
};
